<template>
  <div
    class="userinfo-page"
    data-test="page-userinfo">
    <h4 class="t-c m-b font-normal"> Tell us a little about yourself </h4>
    <p class="t-c m-b-3 sub-header"> This information stays private and helps us show you podcasts you’ll love. </p>
    <el-form
      ref="infoForm"
      :model="user"
      :rules="rules"
      :show-message="false"
      :status-icon="true"
      @keyup.enter.native="onSubmit">
      <el-form-item
        prop="dob"
        label="What's your date of birth?"
        class="dob">
        <el-row :gutter="10">
          <el-col
            :md="11"
            :sm="11"
            :xs="11">
            <el-select
              v-model="user.dob.month"
              placeholder="-"
              @change="onDateChange">
              <el-option
                v-for="(next_item, index) in months"
                :label="next_item.name"
                :value="next_item.month"
                :key="index"/>
            </el-select>
          </el-col>
          <el-col
            :md="6"
            :sm="6"
            :xs="6">
            <el-select
              v-model="user.dob.day"
              placeholder="-"
              @change="onDateChange">
              <el-option
                v-for="day in days"
                :key="day"
                :value="day"
                :label="day"/>
            </el-select>
          </el-col>
          <el-col
            :md="7"
            :sm="7"
            :xs="7">
            <el-select
              v-model="user.dob.year"
              placeholder="-"
              @change="onDateChange">
              <el-option
                v-for="(year, index) in years"
                :key="index"
                :label="year"
                :value="year"/>
            </el-select>
          </el-col>
        </el-row>
        <p
          v-if="ageError"
          class="error-msg m-b-0">Sorry, you don't meet our minimum age requirements</p>
      </el-form-item>
      <el-form-item
        prop="gender"
        label="What's your gender?">
        <el-select
          v-model="user.gender"
          class="full-width"
          placeholder="Gender">
          <el-option
            :value="'prefer-not-say'"
            label="Prefer not to say"/>
          <el-option
            :value="'male'"
            label="Male"/>
          <el-option
            :value="'female'"
            label="Female"/>
          <el-option
            :value="'non-binary'"
            label="Non Binary"/>
        </el-select>
      </el-form-item>
      <div class="t-c m-t-3 m-b-3 action-buttons">
        <!-- <el-button class="btn-transparent large" type="plain" @click="skip">Skip</el-button> -->
        <el-button
          v-loading="loading"
          :disabled="!user.birth_date || ageError || !user.gender"
          class="large"
          type="primary"
          @click="next">Next</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import User from '../../services/User';
import PageMixin from '../../shared/pageMixin';

export default {
  mixins: [PageMixin],
  data() {
    // const checkAge = (rule, value, callback) => {
    //   this.ageError = false;
    //   if (!value) {
    //     return callback(new Error('Please input the age'));
    //   }

    //   const age = parseInt(value, 10);
    //   if (!Number.isInteger(age)) {
    //     callback(new Error('Please input digits'));
    //   } else if (age < 13) {
    //     this.ageError = true;
    //     callback(new Error('Age must be greater than 18'));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      pageName: 'Demographics',
      user: {
        dob: {},
      },
      rules: {
        // age: { validator: checkAge, trigger: 'blur' },
        gender: { required: true, message: 'Gender is required', trigger: 'blur' },
      },
      ageError: false,
      userProvider: new User(),
      dateFormat: {
        day: '',
        month: '',
        year: '',
      },
      days: [],
      years: [],
      loading: false,
      months: [
        { month: '01', name: 'January' },
        { month: '02', name: 'February' },
        { month: '03', name: 'March' },
        { month: '04', name: 'April' },
        { month: '05', name: 'May' },
        { month: '06', name: 'June' },
        { month: '07', name: 'July' },
        { month: '08', name: 'August' },
        { month: '09', name: 'September' },
        { month: '10', name: 'October' },
        { month: '11', name: 'November' },
        { month: '12', name: 'December' },
      ],
    };
  },
  watch: {
    '$store.getters.user': function (newVal) {
      this.setUserDoBAndGender(newVal);
    },
  },
  beforeMount() {
    if (this.$store.getters.loggedIn || !this.$store.getters.creating_account.signup_completed) {
      this.$router.push('/listen');
      return;
    }
    const { user } = this.$store.getters;
    this.setUserDoBAndGender(user);
    this.initYear();
    this.initDays();
  },
  mounted() {
    window.eventBus.$emit('onboarding-step-change', 1);
  },
  methods: {
    setUserDoBAndGender(_user) {
      let user = _user;
      // this.user.birth_date ? this.user.birth_date : user.birth_date
      user = {
        birth_date: this.user.birth_date || user.birth_date,
        gender: this.user.gender || user.gender,
      };
      if (user.birth_date) {
        user.dob = this.parseDate(user.birth_date);
      } else {
        user.dob = this.dateFormat;
      }
      this.user = user;
      this.onDateChange();

      if (this.user && this.user.uuid && !this.user.gender) {
        this.user.gender = 'prefer-not-say';
      }
    },
    initYear() {
      const currentYear = (new Date()).getFullYear();
      const limit = currentYear - 100;

      for (let i = currentYear; i >= limit; i--) {
        this.years.push(i);
      }
    },
    initDays() {
      const days = this.getDaysOfMonth();
      this.days = [];
      for (let i = 0; i < days; i++) {
        this.days.push(i < 9 ? `0${i + 1}` : `${i + 1}`);
      }
    },
    next() {
      this.$refs.infoForm.validate((valid) => {
        if (valid) {
          this.loading = true;

          const { user } = this.$store.getters;
          if (user && user.uuid) {
            this.saveUserInfo();
          } else {
            this.registerUser();
          }
        }
      });
    },
    registerUser() {
      this.userProvider.registerToLuminary().then(() => {
        this.saveUserInfo();
      })
        .catch((error) => {
          this.showErrorMsg(error);
          this.loading = false;
        });
    },
    saveUserInfo() {
      this.userProvider.updateUserInfo({
        birth_date: this.user.birth_date,
        gender: this.user.gender,
      }).then(() => {
        const { user } = this.$store.getters;
        user.birth_date = this.user.birth_date;
        user.gender = this.user.gender;
        this.$store.commit('setUser', user);
        this.$store.commit('setInfoCompleted', true);
        this.showSuccessMsg('User info saved');
        this.$router.push('/user-categories');
        this.triggerSignUpEvent(this.user);
        this.loading = false;
      }).catch((error) => {
        this.showErrorMsg(error.message);
        this.loading = false;
      });
    },
    getDaysOfMonth() {
      let days = 30;
      const leapYear = !!(this.user.dob && this.user.dob.year && this.user.dob.year % 4 === 0);
      if (this.user.dob && this.user.dob.month) {
        switch (this.user.dob.month) {
          case '01':
          case '03':
          case '05':
          case '07':
          case '08':
          case '10':
          case '12':
            days = 31;
            break;
          case '02':
            days = leapYear ? 29 : 28;
            break;
          default:
            days = 30;
            break;
        }
      }
      return days;
    },
    onDateChange() {
      this.initDays();
      const days = this.getDaysOfMonth();
      if (parseInt(this.user.dob.day, 10) > days) {
        this.user.dob.day = '';
      }

      if (this.user.dob && this.user.dob.day !== '' && this.user.dob.month !== '' && this.user.dob.year !== '') {
        this.user.birth_date = this.toDateString(this.user.dob);
      } else {
        this.user.birth_date = '';
      }

      this.validateAgeLimit();
    },
    parseDate(_date) {
      let date = _date;
      const dob = this.dateFormat;
      date = date.split('-');
      if (date.length) {
        [dob.year, dob.month, dob.day] = date;
        // dob.year = date[0];
        // dob.month = date[1];
        // dob.day = date[2];
      }
      return dob;
    },
    toDateString(date) {
      const dob = `${date.year}-${date.month}-${date.day}`;
      return dob;
    },
    validateAgeLimit() {
      const yearLimit = (new Date()).getFullYear() - 13;
      const monthLimit = (new Date()).getMonth() + 1;
      const dateLimit = (new Date()).getDate();
      let dobLimit = `${yearLimit}-${monthLimit}-${dateLimit}`;

      dobLimit = new Date(dobLimit);
      const userDoB = new Date(this.user.birth_date);

      this.ageError = userDoB > dobLimit;
    },
    skip() {
      this.$router.push('/user-categories');
    },
    triggerSignUpEvent(user) {
      if (user) {
        /*
        this.$analytics.track('sign_up');
        this.$analytics.identify(user.uuid, {
          email: user.email,
          birth_date: this.user.birth_date,
          gender: this.user.gender,
        });
        */
      }
    },
  },
};
</script>
<style lang="scss">
.userinfo-page {
  .el-form-item.dob {
    .el-form-item__label {
      width: 100%;
      text-align: left;
    }
  }
  .el-select__caret{
    font-size: 24px !important;
    color: #111 !important;
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/onboarding/Info.vue